// removed by extract-text-webpack-plugin
module.exports = {"block":"_2wvu5DWKSwJetUoL5B1EJN","list":"_2rppe_CZlefs-5c1NNOYeL","scroll-button":"_1QoY8xRTtuoOsGBsedvlX_","adaptiveHeightContainer":"_2UVInocKJWuy3ZGe1A21Co","indicators":"_2y18fRq5Z9GNqNOhMX_wTN","indicator":"_2lh78zapWbJgvecFCjL8Sf","active":"WHI5S7hBSiUxe8wcLkwKJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FullscreenListBlock/FullscreenListBlock.module.scss
// module id = 767
// module chunks = 0